import React from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';
import { Operation } from '../../../services/types/Operation';
import GeneralInfoItem from './GeneralInfoItem';
import { tooltipPreventOverflowModifiers } from '../../../shared/misc/utils';

interface Props {
  operation: Operation;
}
const GIOperationInfo: React.FC<Props> = ({ operation }) => {
  const { t } = useTranslation();
  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('regionCountry')}>
        {operation.region}
        {!!operation.region && !!operation.country ? ' / ' : ''}
        {operation.country}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('sectorSubSector')}>
        {operation.sector}
        {!!operation.sector && !!operation.subSector ? ' / ' : ''}
        {operation.subSector}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('teamLeader')}>{operation.teamLeader}</GeneralInfoItem>
      <GeneralInfoItem title={t('executingAgency')}>
        <div id="executingAgenciesValue">{operation.executingAgencies}</div>
      </GeneralInfoItem>
      <UncontrolledTooltip
        className="tooltip-impact"
        placement="bottom"
        target="executingAgenciesValue"
        modifiers={tooltipPreventOverflowModifiers}
      >
        {operation.executingAgencies}
      </UncontrolledTooltip>
      <GeneralInfoItem title={t('borrower')}>{operation.borrower}</GeneralInfoItem>
      <GeneralInfoItem title={t('frameworkApproach')}>
        {operation.frameworkApproach}
      </GeneralInfoItem>
    </div>
  );
};

export default GIOperationInfo;
